<template>
  <v-layout column>
    <v-flex>
      <router-view />
    </v-flex>
    <leaveConfirmDialog ref="confirm" />
  </v-layout>
</template>

<script>
import LeaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';

export default {
    name: 'AddFamilyExternal',
    components: { LeaveConfirmDialog },
    inject: ['$validator'],
    beforeRouteEnter (to, from, next) {
        if (from.name === null && to.name !== 'family-welcome-info') {
            next({ name: 'family-welcome-info' });
        } else {
            next();
        }
    },
    beforeRouteLeave (to, from, next) {
        if (this.isFormChanged) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    this.$store.commit('familyData/clearFormData');
                    this.$store.commit('reporterData/clearFormData');
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('reporterData/clearFormData');
            next();
        }
    },
    computed: {
        isFormChanged () {
            if (this.$route.name === 'family-summary-external') {
                return false;
            }
            return (
                Object.keys(this.formFields).some((key) => this.formFields[key].flags.changed) ||
        this.routeName
            );
        },
        routeName () {
            return this.$route.name !== 'family-reporter-external';
        },
        formFields () {
            return this.$validator._base.fields.items;
        }
    },
    created () {
        this.$store.commit('familyData/setConsentPageVisible', true);
        if (this.$route.query) {
            this.$store.commit('familyData/setUTMParams', this.$route.query);
        }
    }
};
</script>
